import { useState, useEffect } from "react";
import axios from "axios";
import GOLD from "./gold_shield.png";
import SILVER from "./silver_shield.png";
import "./DigitalGold.css";
import Swal from "sweetalert2";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import { Autocomplete, Box, TextField } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";

const DigitalGold = () => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const baseUrl1 = import.meta.env.VITE_MAIN_URL;
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const navigate = useNavigate();
  const [selectedMetal, setSelectedMetal] = useState("gold");
  const [isGoldSelected, setIsGoldSelected] = useState(true);
  const [isRupeeSelected, setIsRupeeSelected] = useState(true);
  const [rupeeValue, setRupeeValue] = useState("");
  const [gramValue, setGramValue] = useState("");
  const [goldPrice, setGoldPrice] = useState("");
  const [silverPrice, setSilverPrice] = useState("");
  const [timer, setTimer] = useState(180);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  // get userList start
  const getAllUsers = async () => {
    try {
      // const url = `${baseUrl}${"/user"}`;
      const url = `/user`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });
      const userList = response.data.data;
      // console.log(response, "userList");
      setSelectedUser(userList);
    } catch (error) {
      console.error("Error connecting to API", error);
    }
  };
  useEffect(() => {
    getAllUsers();
  }, []);

  const handleUserSelection = async (e, value) => {
    // const _id = e.target.value;
    setSelectedId(value._id);
  };

  // end userList

  useEffect(() => {
    if (isGoldSelected) {
      getGoldLive();
    } else {
      getSilverLive();
    }
  }, [isGoldSelected]);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const getGoldLive = async () => {
    try {
      const url = `/merchant/OnlineLiveRates`;
      // const url = `${baseUrl1}/merchant/OnlineLiveRates`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });
      const liveValue = response.data.data;
      const goldBuyPrice = liveValue[0].gBuy;
      setGoldPrice(goldBuyPrice);
    } catch (error) {
      console.error("Error connecting to API", error);
    }
  };

  const getSilverLive = async () => {
    try {
      const url = `/merchant/OnlineLiveRates`;
      // const url = `${baseUrl1}/merchant/OnlineLiveRates`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });
      const liveValue = response.data.data;
      const liveSilver = liveValue[0].sBuy;
      setSilverPrice(liveSilver);
    } catch (error) {
      console.error("Error connecting to API", error);
    }
  };

  const createPurposal = async () => {
    if (!rupeeValue && !gramValue) {
      Swal.fire({
        icon: "error",
        title: "please fill the value",
        // text: d.message,
      });
      return;
    }
    setLoading(true);
    const weight = isRupeeSelected
      ? (rupeeValue / (isGoldSelected ? goldPrice : silverPrice)).toFixed(4)
      : gramValue;
    const amount = isRupeeSelected
      ? rupeeValue
      : (gramValue * (isGoldSelected ? goldPrice : silverPrice)).toFixed(2);

    let data = {
      metalType: selectedMetal,
    };

    if (isRupeeSelected) {
      data.amount = amount;
    } else {
      data.quantity = weight;
    }

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `/buyQuote/${selectedId}`,
      // url: `${baseUrl}/buyQuote/${selectedId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(data),
    };

    axiosInstance
      .request(config)
      .then((response) => {
        // console.log(response.data.data[0], ">>>>>>>>>>>>");
        return response.data;
      })
      .then((d) => {
        if (d.error === false) {
          setLoading(false);
          const _id = d.data[0]._id;
          const responseData = d.data[0];
          const queryParams = encodeURIComponent(
            JSON.stringify({
              ...data,
              pricePerGram: responseData.pricePerGram,
              totalQuantity: responseData.totalQuantity,
              gst: responseData.gst,
              amountAfterTax: responseData.amountAfterTax,
              merchant: responseData.merchantTransactionId,
            }),
          );

          navigate(`/OrderSummary/${selectedId}/${queryParams}`);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: d.message,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const handleMetalButtonClick = (isGold) => {
    if (!selectedUser) return;
    setIsGoldSelected(isGold);
    setSelectedMetal(isGold ? "gold" : "silver");
    setTimer(180); // Reset the timer to 3 minutes
    if (isGold) {
      getGoldLive();
    } else {
      getSilverLive();
    }
  };

  const handleUnitButtonClick = (isRupee) => {
    if (!selectedUser) return;
    setIsRupeeSelected(isRupee);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const gstRate = 1.03;
    if (isRupeeSelected) {
      setRupeeValue(value);
      setGramValue(
        value
          ? (
              value /
              gstRate /
              (isGoldSelected ? goldPrice : silverPrice)
            ).toFixed(4)
          : "",
      );
    } else {
      setGramValue(value);
      setRupeeValue(
        value
          ? (
              value *
              (isGoldSelected ? goldPrice : silverPrice) *
              gstRate
            ).toFixed(2)
          : "",
      );
    }
  };

  const handleAmountButtonClick = (amount) => {
    const value = amount.replace("₹", "");
    const gstRate = 1.03;
    if (isRupeeSelected) {
      setRupeeValue(value);
      setGramValue(
        value
          ? (
              value /
              gstRate /
              (isGoldSelected ? goldPrice : silverPrice)
            ).toFixed(4)
          : "",
      );
    } else {
      setGramValue(value);
      setRupeeValue(
        value
          ? (
              value *
              (isGoldSelected ? goldPrice : silverPrice) *
              gstRate
            ).toFixed(2)
          : "",
      );
    }
  };

  const metal = isGoldSelected ? "GOLD" : "SILVER";
  const metalPrice = isGoldSelected ? `₹${goldPrice}/gm` : `₹${silverPrice}/gm`;
  const metalImage = isGoldSelected ? GOLD : SILVER;
  const unit = isRupeeSelected ? "₹" : "gm";
  const metalTag = isGoldSelected ? "24K 99.9% Pure Gold" : "999.9 Pure Silver";

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  return (
    <Box>
      <div className={loading ? "blurred" : ""}>
        {loading && (
          <div className="loader-overlay ">
            <Loader />
          </div>
        )}
        <header className="header-container ">
          <div className="dropdown-container ">
            <Autocomplete
              className="dropdown "
              options={selectedUser}
              getOptionLabel={(option) => option?.name || option?.phone || ""}
              onChange={handleUserSelection}
              key={(option) => option._id} // Use a unique key for React
              renderOption={(props, option) => (
                <li
                  {...props}
                  key={option._id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px",
                  }}
                >
                  <span style={{ fontSize: 12 }}>{option?.name}</span>
                  <span style={{ fontSize: 12 }}>{option?.phone}</span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search User *"
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </div>
          <div className="button-group">
            <button
              className={`final-btn gold-btn gl ${
                isGoldSelected ? "active" : ""
              }`}
              onClick={() => {
                if (!selectedUser) {
                  Swal.fire({
                    icon: "warning",
                    title: "No User Selected",
                    text: "Please select a user first.",
                    confirmButtonColor: "#4a2a7d",
                  });
                } else {
                  handleMetalButtonClick(true);
                }
              }}
            >
              Gold
            </button>
            <button
              className={`final-btn silver-btn gl ${
                !isGoldSelected ? "active" : ""
              }`}
              onClick={() => {
                if (!selectedUser) {
                  Swal.fire({
                    icon: "warning",
                    title: "No User Selected",
                    text: "Please select a user first.",
                    confirmButtonColor: "#4a2a7d",
                  });
                } else {
                  handleMetalButtonClick(false);
                }
              }}
            >
              Silver
            </button>
          </div>
        </header>
        <div className="bordered-div">
          <div className="inner-container">
            <div className="inner-div">
              <button
                className="btn card-btn"
                style={{ backgroundColor: "#4a2a7d", color: "white" }}
              >
                {metal}
              </button>
              <h3>{`${metal} PRICE`}</h3>
              <div className="paragst">
                <p className={isGoldSelected ? "medium-text" : "medium-text1"}>
                  {metalPrice}
                </p>

                <p className={isGoldSelected ? "gst" : "gst1"}>+3% GST</p>
              </div>
              <p className="mini-text">{metalTag}</p>
            </div>
            <div className="inner-div hide-text">Div 2</div>
            <div className="inner-div">
              <div
                className=""
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={metalImage}
                  alt={`${metal} image`}
                  style={{ width: "110px", marginBottom: "1rem" }}
                />
              </div>

              <div className="timer">
                <p className="mini-text">{`${metal} rate expires in :`}</p>
                <p className="time">{formatTime(timer)}</p>
              </div>
            </div>
          </div>
          <div className="button-row-bottom">
            <div className="irg">
              <button
                className={`final-btn ir-btn ${
                  isRupeeSelected ? "active" : ""
                }`}
                onClick={() => {
                  if (!selectedUser) {
                    Swal.fire({
                      icon: "warning",
                      title: "No User Selected",
                      text: "Please select a user first.",
                      confirmButtonColor: "#4a2a7d",
                    });
                  } else {
                    handleUnitButtonClick(true);
                  }
                }}
              >
                In Rupee
              </button>
              <div className="vl"></div>
              <button
                className={`final-btn ig-btn ${
                  !isRupeeSelected ? "active" : ""
                }`}
                onClick={() => {
                  if (!selectedUser) {
                    Swal.fire({
                      icon: "warning",
                      title: "No User Selected",
                      text: "Please select a user first.",
                      confirmButtonColor: "#4a2a7d",
                    });
                  } else {
                    handleUnitButtonClick(false);
                  }
                }}
              >
                In Grams
              </button>
            </div>
          </div>
          <div
            className={
              selectedMetal == "gold"
                ? "input-container"
                : "input-container-silver"
            }
          >
            <div className="input-border">
              <div className="input-1">
                <span className={selectedMetal == "gold" ? "rupee" : "silver"}>
                  {unit}
                </span>
              </div>
              <input
                type="text"
                value={isRupeeSelected ? rupeeValue : gramValue}
                onChange={handleInputChange}
                style={{ width: "100%" }}
                className={selectedMetal == "gold" ? "rupee" : "silver"}
              />
              <div className="input-2" style={{ width: "100%" }}>
                <span className={selectedMetal == "gold" ? "rupee" : "silver"}>
                  {isRupeeSelected ? `${gramValue}gm` : `₹ ${rupeeValue}`}
                </span>
              </div>
            </div>
          </div>
          <div className="button-container grid">
            {["100", "200", "300", "400", "500"].map((amount) => (
              <button
                className="btn card-btn"
                key={amount}
                onClick={() => handleAmountButtonClick(amount)}
                style={{ backgroundColor: "#4a2a7d", color: "white" }}
              >
                {isRupeeSelected ? `₹ ${amount}` : `${amount}gm`}
              </button>
            ))}
          </div>
          <div
            className="button-container"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              type="button"
              className="btn card-btn submit-btn"
              onClick={() => {
                if (!selectedId) {
                  Swal.fire({
                    icon: "warning",
                    title: "No User Selected",
                    text: "Please select a user first.",
                    confirmButtonColor: "#4a2a7d",
                  });
                } else {
                  createPurposal();
                }
              }}
              style={{
                backgroundColor: "#4a2a7d",
                color: "white",
                width: "10rem",
                marginBottom: "0px",
              }}
            >
              Proceed To Pay
            </button>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default DigitalGold;
